module.exports = __webpack_public_path__ + "static/media/logo.a26bfa7a.png";